import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="admins--receipts--switch-content"
export default class extends Controller {
  static targets = [
    "switchContent",
    "content",
    "form"
  ]

  switch(event) {
    let target

    if (event instanceof Event) {
      target = event.target.value
    } else {
      target = event
    }

    switch (target) {
      case "form":
        this.formTarget.classList.remove("hidden")
        this.contentTarget.classList.add("hidden")
        break;
      case "content":
        this.formTarget.classList.add("hidden")
        this.contentTarget.classList.remove("hidden")
        break;
    }
  }

  switchContentTargetConnected(target) {
    if (target.dataset.attachmentStatus === "true") {
      this.switch("content")
    }
  }
}
